<template>
  <div class="table-container px-4 py-4">
    <table class="table table-bordered table-hover table-responsive">
      <thead>
        <tr>
          <th rowspan="3" class="align-middle text-center dateColColor">Time</th>
          <th rowspan="3" class="align-middle text-center sensorColColor">OP Temp Range</th>
          <!-- First Row: Hub Names -->
          <template v-if="confirmDeviceChecked">
            <template v-for="(hubData, hubName) in tableData" :key="hubName">
              <th class="hubColColor text-center" :colspan="getSensorColumnCount(hubData)">
                Hub: {{ hubName }}
              </th>
            </template>
          </template>
        </tr>
        <tr>
          <!-- Second Row: Sensor Names -->
          <template v-if="confirmDeviceChecked">
            <template v-for="hubData in tableData" :key="hubData">
              <template v-for="(sensorData, sensorName) in hubData" :key="sensorName">
                <th class="sensorColColor text-center" :colspan="visibleFields.length">Sensor: {{ sensorName }}</th>
              </template>
            </template>
          </template>
          <template v-else>
            <template v-for="sensorName in Object.keys(flattenedSensors)" :key="sensorName">
              <th class="sensorColColor text-center" :colspan="visibleFields.length">Sensor: {{ sensorName }}</th>
            </template>
          </template>
        </tr>
        <tr>
          <!-- Third Row: Dynamic Headers -->
          <template v-if="confirmDeviceChecked">
            <template v-for="hubData in tableData" :key="hubData">
              <template v-for="(sensorData, sensorName) in hubData" :key="sensorName">
                <template v-for="field in visibleFields" :key="field">
                  <th class="align-top text-center">{{ fieldLabels[field] }}</th>
                </template>
              </template>
            </template>
          </template>
          <template v-else>
            <template v-for="sensorName in Object.keys(flattenedSensors)" :key="sensorName">
              <template v-for="field in visibleFields" :key="field">
                <th class="align-top text-center">{{ fieldLabels[field] }}</th>
              </template>
            </template>
          </template>
        </tr>
      </thead>

      <tbody>
        <!-- Iterate through each unique date -->
        <template v-for="(dateGroup, index) in groupedDates" :key="index">
          <!-- Create a row for each OP Temp Range (Low, Medium, High) -->
          <template v-for="(opTempRange, opIndex) in ['Low', 'Medium', 'High']" :key="opIndex">
            <tr>
              <!-- Time Column: Merge rows for the same date -->
              <template v-if="opIndex === 0">
                <td :rowspan="3" class="dateColColor align-middle">
                  {{ new Date(dateGroup.date).toLocaleDateString("en-US", { month: "long", day: "numeric" }) }}
                </td>
              </template>
              <!-- OP Temp Range Column -->
              <td class="sensorColColor">{{ opTempRange }}</td>
              <!-- Iterate through hubs and sensors -->
              <template v-for="(hubData, hubName) in tableData" :key="hubName">
                <template v-for="(sensorData, sensorName) in hubData" :key="sensorName">
                  <!-- Find the entry for the current date and OP Temp Range -->
                  <template v-if="getSensorDataForDateAndTemp(sensorData, dateGroup.date, opTempRange)">
                    <template v-for="field in visibleFields" :key="field">
                      <td class="text-center">{{ getSensorDataForDateAndTemp(sensorData, dateGroup.date, opTempRange)[field] }}</td>
                    </template>
                  </template>
                  <!-- If no data for the current date and OP Temp Range, display empty cells -->
                  <template v-else>
                    <td v-for="field in visibleFields" :key="field"></td>
                  </template>
                </template>
              </template>
            </tr>
          </template>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "ThreeDTable",
  data() {
    return {
      tableData:{
    "IoT Hub": {
        "Thermal Mass Flow Meter 1": [
            {
                "date": "2024-10-01T00:00:00Z",
                "hub": "IoT Hub",
                "sensorname": "Thermal Mass Flow Meter 1",
                "total_alarms": 151,
                "uptime": "0.0 Hrs",
		"OPTempRange": "Low"
            },
 {
                "date": "2024-10-01T00:00:00Z",
                "hub": "IoT Hub",
                "sensorname": "Thermal Mass Flow Meter 1",
                "total_alarms": 200,
                "uptime": "0.5 Hrs",
		"OPTempRange": "Medium"
            },

 {
                "date": "2024-10-01T00:00:00Z",
                "hub": "IoT Hub",
                "sensorname": "Thermal Mass Flow Meter 1",
                "total_alarms": 250,
                "uptime": "0.10 Hrs",
		"OPTempRange": "High"
            },

            {
                "date": "2024-11-01T00:00:00Z",
                "hub": "IoT Hub",
                "sensorname": "Thermal Mass Flow Meter 1",
                "total_alarms": 100,
                "uptime": "7.0 Hrs",
		"OPTempRange": "Low"
            },
            {
                "date": "2024-11-01T00:00:00Z",
                "hub": "IoT Hub",
                "sensorname": "Thermal Mass Flow Meter 1",
                "total_alarms": 102,
                "uptime": "8.0 Hrs",
		"OPTempRange": "Medium"
            },

            {
                "date": "2024-11-01T00:00:00Z",
                "hub": "IoT Hub",
                "sensorname": "Thermal Mass Flow Meter 1",
                "total_alarms": 110,
                "uptime": "9.0 Hrs",
		"OPTempRange": "High"
            },

                   ]
    },
    "IoT Hub 1": {
        "Thermal Mass Flow Meter 4": [
            {
                "date": "2024-10-01T00:00:00Z",
                "hub": "IoT Hub 1",
                "sensorname": "Thermal Mass Flow Meter 4",
                "total_alarms": 50,
                "uptime": "1.0 Hrs",
		"OPTempRange": "Low"

            },
		 {
                "date": "2024-10-01T00:00:00Z",
                "hub": "IoT Hub 1",
                "sensorname": "Thermal Mass Flow Meter 4",
                "total_alarms": 52,
                "uptime": "2.0 Hrs",
		"OPTempRange": "Medium"

            },
 {
                "date": "2024-10-01T00:00:00Z",
                "hub": "IoT Hub 1",
                "sensorname": "Thermal Mass Flow Meter 4",
                "total_alarms": 53,
                "uptime": "3.0 Hrs",
		"OPTempRange": "High"

            },

            {
                "date": "2024-11-01T00:00:00Z",
                "hub": "IoT Hub 1",
                "sensorname": "Thermal Mass Flow Meter 4",
                "total_alarms": 100,
                "uptime": "10.0 Hrs",
		"OPTempRange": "Low"

            },
 {
                "date": "2024-11-01T00:00:00Z",
                "hub": "IoT Hub 1",
                "sensorname": "Thermal Mass Flow Meter 4",
                "total_alarms": 200,
                "uptime": "20.0 Hrs",
		"OPTempRange": "Medium"

            },

 {
                "date": "2024-11-01T00:00:00Z",
                "hub": "IoT Hub 1",
                "sensorname": "Thermal Mass Flow Meter 4",
                "total_alarms": 391,
                "uptime": "30.0 Hrs",
		"OPTempRange": "High"

            },

                   ]
    }
},
    };
  },
  computed: {
    flattenedSensors() {
      const sensors = {};
      for (const hubData of Object.values(this.tableData)) {
        for (const [sensorName, sensorData] of Object.entries(hubData)) {
          sensors[sensorName] = sensorData;
        }
      }
      return sensors;
    },
    uniqueDates() {
      const dates = [];
      for (const hubData of Object.values(this.tableData)) {
        for (const sensorData of Object.values(hubData)) {
          sensorData.forEach((entry) => {
            if (!dates.includes(entry.date)) {
              dates.push(entry.date);
            }
          });
        }
      }
      return dates.sort(); // Sort dates for consistent rendering
    },
    groupedDates() {
      return this.uniqueDates.map((date) => ({
        date,
      }));
    },
    visibleFields() {
      const fields = new Set();
      for (const hubData of Object.values(this.tableData)) {
        for (const sensorData of Object.values(hubData)) {
          sensorData.forEach((entry) => {
            Object.keys(entry).forEach((key) => {
              if (key !== "date" && key !== "hub" && key !== "sensorname" && key !== "OPTempRange") {
                fields.add(key);
              }
            });
          });
        }
      }
      return Array.from(fields);
    },
    fieldLabels() {
      return {
        uptime: "Up Time",
        downtime: "Down Time",
        total_alarms: "No. of Alarms",
        autoresolved_alarms: "No. of Auto Resolved",
        manualresolved_alarms: "No. of Manual Resolved",
        unresolved_alarms: "Unresolved Alarms",
      };
    },
  },
  methods: {
    getSensorDataForDateAndTemp(sensorData, date, opTempRange) {
      return sensorData.find(
        (entry) => entry.date === date && entry.OPTempRange === opTempRange
      ) || null;
    },
    getSensorColumnCount(hubData) {
      return Object.keys(hubData).length * this.visibleFields.length;
    },
  },
};
</script>
